import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './left-side-image-name.vue';

import { LiveData } from '../../views/live/index';

declare var flowplayer: Function
declare var WebRTCAdaptor: any

@Component({
    mixins: [template],
})

export default class LeftSideImageName extends Vue {

    @Prop(Object) readonly auctionData!: LiveData;

    streamId?: string
    streamServerUrl?: string

    feedUrl = 'wss://turn.millicast.com/millisock'

    videoContainer: any
    remoteVideo: any
    playButton: any

    videoPlaying: boolean = false
    videoLoading: boolean = true
    showPlayButton: boolean = false

    mounted() {

        this.videoContainer = document.getElementById('video_container')
        this.remoteVideo = document.getElementById('remoteVideo')
        this.playButton = document.getElementById('play_button')

        this.$store.watch(
            (state) => {
                return state.liveStreamId;
            },
            (streamId: string) => {
                if (streamId && this.streamId !== streamId) {
                    this.tryInitLiveStream()
                }
            },
            {
                deep: true
            }
        );

        this.$store.watch(
            (state) => {
                return state.liveStreamUrl;
            },
            (streamServerUrl: string) => {
                if (streamServerUrl && this.streamServerUrl !== streamServerUrl) {
                    this.tryInitLiveStream()
                }
            },
            {
                deep: true
            }
        );

        this.tryInitLiveStream()

    }

    tryInitLiveStream() {

        this.streamId = this.$store.getters.getLiveStreamId
        this.streamServerUrl = this.$store.getters.getLiveStreamUrl

        this.initializeWebRTCPlayer()

    }

    isMobile() {
        if (/Android|webOS|iPhone||iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return true
        } else {
            return false
        }
    }

    playClicked() {

        this.showPlayButton = false

        this.remoteVideo.play().then((value: any) => {
            this.videoPlaying = true
        }).catch((error: any) => {
            alert('Live streamul nu se poate reda pe acest dispozitiv')
        });

    }

    playWebRTCVideo() {

        console.log('button pressed')

        this.showPlayButton = false

        this.remoteVideo.play().then((value: any) => {
            this.showPlayButton = false
            this.videoPlaying = true
        }).catch((error: any) => {
            this.showPlayButton = true
            this.videoPlaying = false
            console.log('User interaction needed to start playing');
        });


    }

    initializeWebRTCPlayer() {

        if (!this.streamServerUrl) return

        if (!this.streamId) return

        this.remoteVideo.style.display = 'block';

        let pc_config = undefined;

        let sdpConstraints = {
            OfferToReceiveAudio: true,
            OfferToReceiveVideo: true

        };
        let mediaConstraints = {
            video: false,
            audio: false
        };

        let path = this.streamServerUrl.split('://')[1] + '/WebRTCAppEE/websocket';

        let websocketURL = 'ws://' + path;

        if (this.streamServerUrl.startsWith('https')) {
            websocketURL = 'wss://' + path;
        }

        let webRTCAdaptor = new WebRTCAdaptor({
            websocket_url: websocketURL,
            mediaConstraints: mediaConstraints,
            peerconnection_config: pc_config,
            sdp_constraints: sdpConstraints,
            remoteVideoId: 'remoteVideo',
            isPlayMode: true,
            debug: true,
            callback: (info: string, description: string) => {

                if (info == 'initialized') {
                    console.log('initialized');
                    webRTCAdaptor.getStreamInfo(this.streamId);
                }
                else if (info == 'streamInformation') {
                    console.log('stream information');
                    webRTCAdaptor.play(this.streamId, 'null');
                    this.videoLoading = false
                }
                else if (info == 'play_started') {
                    // joined the stream
                    console.log('play started');
                    // document.getElementById("video_info").style.display = "none";
                    this.playWebRTCVideo();
                } else if (info == 'play_finished') {
                    // leaved the stream
                    console.log('play finished');
                    this.videoPlaying = false
                    // check that publish may start again
                    setTimeout(() => {
                        webRTCAdaptor.getStreamInfo(this.streamId);
                    }, 3000);
                }
                else if (info == 'closed') {
                    this.videoPlaying = false
                    // console.log("Connection closed");
                    if (typeof description != 'undefined') {
                        console.log('Connecton closed: ' + JSON.stringify(description));
                    }
                }

            },
            callbackError: (error: any) => {
                // some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError

                console.log('error callback: ' + JSON.stringify(error));

                if (error == 'no_stream_exist') {

                    /**
                     * If HLS is in the play order then try to play HLS, if not wait for WebRTC stream
                     * In some cases user may want to remove HLS from the order and force to play WebRTC only
                     * in these cases player only waits for WebRTC streams
                     */

                    setTimeout(() => {
                        webRTCAdaptor.getStreamInfo(this.streamId);
                    }, 3000);

                }

                // alert(JSON.stringify(error));
            }
        });



    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/left-side-image-name/index.ts